import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BookingProvider } from './context/BookingContext';
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider, debugTokenStatus } from "firebase/app-check";

// --- FIREBASE CONFIGURATION ---
const firebaseConfig = {
  apiKey: "AIzaSyBvdnnZn6ZQG2RcDdp4uFxuOVmOwH-QRv4",
  authDomain: "website-149c0.firebaseapp.com",
  databaseURL: "https://website-149c0-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "website-149c0",
  storageBucket: "website-149c0.firebasestorage.app",
  messagingSenderId: "549339077566",
  appId: "1:549339077566:web:d2e5b276badf02665a37ef",
  measurementId: "G-V738X8PE8M"
};

const app = initializeApp(firebaseConfig);

// --- APP CHECK ---
if (typeof window !== 'undefined') {
  // Check if we are in local development
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  if (isLocalhost) {
    // Enable debug mode for local development.
    // Firebase will print the debug token to the console — add it to:
    // Firebase Console > App Check > Apps > Add debug token
    (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider('6LefN-sqAAAAAGxYp9CqC7T8P_u9_M8W_F_L_L_L'), // Replace with your actual reCAPTCHA Enterprise Site Key
    isTokenAutoRefreshEnabled: true
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BookingProvider>
      <App />
    </BookingProvider>
  </React.StrictMode>
);
